import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import { useOverlayState } from '../../hooks/useOverlayState';

import Button from '../../design-system/Button/Button';
import { ButtonIcon } from '../../design-system';
import { ArrowGoBackLineIcon, More2FillIcon } from '../../design-system/Icons';

const BackBreadcrumbActions = ({ backLinkHref, breadcrumbs, renderMoreOptions }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { isOpened, open: openPopup, close: closePopup } = useOverlayState();

    return (
        <div className="py-3 px-4 sm:px-6 flex justify-between min-[380px]:items-center gap-2 bg-white border-b-1 border-neutral-200">
            <div className="flex flex-col items-start min-[380px]:flex-row min-[380px]:items-center gap-x-5 gap-y-0.5">
                <Button
                    type="link"
                    size="xs"
                    text="Back"
                    leadingIcon={ArrowGoBackLineIcon}
                    onClick={() => navigate(backLinkHref, { state: { from: location } })}
                />
                <p className="font-body text-body-regular-s text-neutral-300">{breadcrumbs}</p>
            </div>

            <div className="relative z-10 transform translate-y-[-4px] min-[380px]:translate-y-[0]">
                <ButtonIcon type="link" size="sm" icon={More2FillIcon} onClick={openPopup} />

                {isOpened && renderMoreOptions({ onClose: closePopup })}
            </div>
        </div>
    );
};

BackBreadcrumbActions.propTypes = {
    backLinkHref: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    breadcrumbs: PropTypes.string.isRequired,
    renderMoreOptions: PropTypes.func.isRequired,
};

export default BackBreadcrumbActions;
